// Bands follow the summary-card thresholds SUMMARY_THRESHOLDS = 50/75/100
// (ruling 2026-08-21, aligned same day). Alert emails and the alert-settings
// fired badges use the SEPARATE alert thresholds 75/90/100 - do not colour
// those with this map.
export type ConsumptionBand = "ok" | "warn50" | "warn75" | "over100" | "pending";

export function consumptionBand(pct: number | null): ConsumptionBand {
  if (pct === null) return "pending";
  if (pct >= 100) return "over100";
  if (pct >= 75) return "warn75";
  if (pct >= 50) return "warn50";
  return "ok";
}

// antd Tag/color tokens
export const BAND_COLORS: Record<ConsumptionBand, string> = {
  ok: "green",
  warn50: "gold",
  warn75: "orange",
  over100: "red",
  pending: "default",
};

// CSS colors for non-Tag consumers (e.g. Statistic valueStyle). BAND_COLORS
// holds antd Tag color NAMES, not CSS colors - "default" isn't a CSS color
// at all, so don't reuse that map directly. Hex values match the antd
// palette swatch behind each Tag name above, for visual consistency.
export const BAND_CSS_COLORS: Record<ConsumptionBand, string> = {
  ok: "#52c41a",
  warn50: "#faad14",
  warn75: "#fa8c16",
  over100: "#f5222d",
  pending: "rgba(0, 0, 0, 0.45)",
};
